import { features } from "app/features";
import { _t } from "app/i18n/i18n";
import { preventDefault } from "lib/utils";
import React, { useState } from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { Suggestion } from "./AutoSuggestions";

export function CompanySuggestions({ keyword, setKeyword, companies, nCompanyColumns, forHtmlReport, nairaMode, onNairaSearch }) {
  const [companyRadio, setCompanyRadio] = useState("CompanyWithTicker");
  if (!features.autocompleteKeywordSuggestions || !keyword || !keyword.trim() || keyword.includes('"')) return null;
  const companySuggestions = getCompanySuggestions(companies, companyRadio);

  return (
    <>
      <ListGroupItem className="pl-2 pb-2 pt-3 mb-0">
        <h4 className="font-weight-light mb-0 pr-4">{_t("Companies")}</h4>
        {PrimaryStockToggle(companyRadio, setCompanyRadio)}
      </ListGroupItem>
      <ListGroup className="list-group-flush d-block" style={{ columnCount: nCompanyColumns }}>
        {companySuggestions.map((suggestion, idx) => {
          const key = `${suggestion.CategoryName}-${idx}`;
          return <Suggestion key={key} suggestion={suggestion} setKeyword={setKeyword} forHtmlReport={forHtmlReport} nairaMode={nairaMode} onNairaSearch={onNairaSearch} />;
        })}
      </ListGroup>
    </>
  );
}

// preventDefault prevents blur event closing autocomplete on radio click
function PrimaryStockToggle(companyRadio, setCompanyRadio) {
  const onChange = (ev) => setCompanyRadio(ev.target.id);
  return (
    <section onMouseDown={preventDefault} className="mt-1 text-right">
      <label id="CompanyWithTicker" onClick={preventDefault} onMouseDown={onChange} className="mb-0">
        <input
          type="radio"
          id="CompanyWithTicker"
          name="companyToggle"
          checked={companyRadio === "CompanyWithTicker"}
          onChange={onChange}
          className="ml-2 mr-1 mb-0"
        />
        {_t("All")}
      </label>
      <label id="securityType" onClick={preventDefault} onMouseDown={onChange} className="mb-0 ml-2">
        <input
          type="radio"
          id="securityType"
          name="companyToggle"
          checked={companyRadio === "securityType"}
          onChange={onChange}
          className="ml-2 mr-1 mb-0"
        />
        {_t("Primary Stock Only")}
      </label>
    </section>
  );
}

function getCompanySuggestions(companies, companyRadio) {
  return companies
    .map((suggestion) => getSuggestions(suggestion, companyRadio))
    .filter((suggestion) => suggestion.CategoryValue);
}

function getSuggestions(suggestion, companyRadio) {
  if (companyRadio === "CompanyWithTicker") {
    return getCompanyWithTickerSuggestion(suggestion);
  }
  return getSecurityTypeSuggestion(suggestion);
}

function getCompanyWithTickerSuggestion(suggestion) {
  return {
    CategoryName: "CompanyWithTicker",
    ...suggestion,
  };
}

function getSecurityTypeSuggestion(suggestion) {
  return {
    CategoryName: "companies.securityType",
    CategoryValue: suggestion.ticker,
    label: suggestion.CategoryValue,
  };
}
